import { transparentize } from 'polished'
import { BLACK } from './primitiveColours'

export const neutralControlPalette: Record<
  App.Design.PaletteType,
  App.Design.NeutralPalette<string>['control']
> = {
  default: {
    white8: transparentize(0.08, BLACK[0]),
    white16: transparentize(0.16, BLACK[0]),
    white24: transparentize(0.24, BLACK[0]),
    white32: transparentize(0.32, BLACK[0]),
    white40: transparentize(0.40, BLACK[0]),
    white56: transparentize(0.56, BLACK[0]),
    black8: transparentize(0.08, BLACK[950]),
    black16: transparentize(0.16, BLACK[950]),
    black24: transparentize(0.24, BLACK[950]),
    black32: transparentize(0.32, BLACK[950]),
    black40: transparentize(0.40, BLACK[950]),
    black56: transparentize(0.56, BLACK[950]),
    black100: BLACK[950],
    color: {
      white: BLACK[0],
      black: BLACK[950],
    },
    opacity: {
      0: '0%',
      8: '8%',
      16: '16%',
      24: '24%',
      32: '32%',
      40: '40%',
      56: '56%',
    },
  },
  inverse: {
    white8: transparentize(0.08, BLACK[950]),
    white16: transparentize(0.16, BLACK[950]),
    white24: transparentize(0.24, BLACK[950]),
    white32: transparentize(0.32, BLACK[950]),
    white40: transparentize(0.40, BLACK[950]),
    white56: transparentize(0.56, BLACK[950]),
    black8: transparentize(0.08, BLACK[0]),
    black16: transparentize(0.16, BLACK[0]),
    black24: transparentize(0.24, BLACK[0]),
    black32: transparentize(0.32, BLACK[0]),
    black40: transparentize(0.40, BLACK[0]),
    black56: transparentize(0.56, BLACK[0]),
    black100: BLACK[0],
    color: {
      white: BLACK[950],
      black: BLACK[0],
    },
    opacity: {
      0: '0%',
      8: '8%',
      16: '16%',
      24: '24%',
      32: '32%',
      40: '40%',
      56: '56%',
    },
  },
}

export const neutralScrimPalette: App.Design.NeutralPalette<string>['scrim'] = {
  white32: transparentize(0.68, BLACK[0]),
  white40: transparentize(0.6, BLACK[0]),
  white56: transparentize(0.44, BLACK[0]),
  black32: transparentize(0.68, BLACK[950]),
  black40: transparentize(0.6, BLACK[950]),
  black56: transparentize(0.44, BLACK[950]),
}
